import styled from 'styled-components';

import { headerVariables } from '../Header/HeaderStyle';

import { breakpoints, colors, fontFamily, zIndex } from '../../ui/variables';

const main = {
  height: {
    iphone: `calc(100vh - ${headerVariables.main.height.iphone}px)`,
  },
};

export const MenuStyle = styled.div`
  ${zIndex.sky};
  background-color: ${colors.mostlyWhite};
  height: ${main.height.iphone};
  left: -125%;
  overflow-y: auto;
  padding: 28px 8px;
  position: fixed;
  top: ${headerVariables.main.height.iphone}px;
  transition: left 300ms;
  width: 100%;

  @media (min-width: ${breakpoints.ipadLandscape.width}px) {
    ${zIndex.floor};
    height: 100%;
    left: initial;
    position: relative;
    top: initial;
    transition: none;
    width: 100%;
  }

  .exam-summary-wrapper {
    margin-bottom: 8px;
  }

  &.show-menu {
    left: 0;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      left: initial;
    }
  }

  .institutions-menu {
    &:not(:last-child) {
      margin-bottom: 36px;
    }

    .institution-box {
      align-items: center;
      background: ${colors.white};
      border-radius: 12px;
      display: block;
      display: flex;
      padding: 16px;
      position: relative;
      width: 100%;

      &.selected-institution {
        border: solid 1px ${colors.limeGreen};

        .institution-check {
          align-items: center;
          background-color: ${colors.limeGreen};
          border-radius: 50%;
          display: flex;
          height: 16px;
          justify-content: center;
          position: absolute;
          right: 16px;
          top: 16px;
          width: 16px;

          svg {
            display: block;
            fill: ${colors.white};
            height: auto;
            width: 8px;
          }
        }
      }

      &.institution-option {
        border: solid 1px ${colors.white};

        &:not(:last-child) {
          margin-bottom: 8px;
        }
      }

      .institution-avatar {
        align-items: center;
        background-color: ${colors.white};
        border: 1px solid ${colors.veryLightGrayishBlue};
        border-radius: 50%;
        display: flex;
        height: 60px;
        justify-content: center;
        margin-right: 12px;
        min-height: 60px;
        min-width: 60px;
        overflow: hidden;
        width: 60px;

        &.text-avatar {
          ${fontFamily.sourceSansPro.bold};
          color: ${colors.softBlue};
          font-size: 28px;
          line-height: 1;
        }

        .institution-image {
          display: block;
          height: auto;
          max-height: 100%;
          max-width: 100%;
          width: auto;
        }
      }

      .institution-information {
        text-align: left;

        .institution-name {
          ${fontFamily.sourceSansPro.bold};
          color: ${colors.veryDarkGrayishBlue};
          font-size: 14px;
          line-height: 18px;

          &:not(:last-child) {
            margin-bottom: 4px;
          }
        }

        .institution-adress {
          ${fontFamily.sourceSansPro.regular};
          color: ${colors.veryDarkGrayishBlue};
          font-size: 12px;
          line-height: 16px;
          max-width: 164px;
        }
      }
    }

    .institution-options-list {
      margin-top: 0;
      max-height: 0;
      overflow: hidden;
      transition: max-height 300ms, margin-top 300ms;

      &.show {
        margin-top: 8px;
        max-height: 9999em;
      }
    }
  }

  .links-menu {
    .links-menu-item {
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }

      &.add-exam-menu-item {
        margin-top: 32px;
      }

      &.qr-code-menu-item {
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          display: none;
        }

        a {
          text-transform: uppercase;
        }
      }

      &.help-menu-item {
        margin-top: 40px;
        width: 96%;
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          margin-top: 80px;
        }
      }
    }
  }
`;
